import { useContext } from 'react';
import { userAuth } from '../contexts/userContext';
import { useNavigate } from 'react-router-dom';
import { getConfig } from '../config';
import getClientSlug from '../helpers/clientSlug.js';

const CommonAPIService = () => {
	const { token, setToken } = useContext(userAuth);
	const navigate = useNavigate();

	async function sendRequest(quary) {
		const web_link = getConfig().REACT_APP_WEB_LINK;
		const slug = getClientSlug();
		const sessionKey = token?.session_key || '';
		const action = String(quary?.action || '').trim();
		const shouldSkipSlug =
			action === 'get_tour_status_list' ||
			action === 'save_tour_status' ||
			action === '/save_tour_status' ||
			action.startsWith('save_tour_status?') ||
			action.startsWith('/save_tour_status?');
		const payload = slug && !shouldSkipSlug ? { ...quary, slug: slug } : quary;
		const headers = {
			'Content-Type': 'application/json',
			Accept: 'application/json',
			'sdk-authorization': `${sessionKey}`,
		};

		if (
			action === 'save_tour_status' ||
			action === '/save_tour_status' ||
			action.startsWith('save_tour_status?') ||
			action.startsWith('/save_tour_status?')
		) {
			headers.session_key = `${sessionKey}`;
		}

		return fetch(web_link, {
			method: 'post',
			headers,
			body: JSON.stringify(payload),
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				return response.json();
			})
			.then((response) => {
				if (response.type === 'error' && response.message === 'Session expired') {
					setToken({});
					localStorage.removeItem('user-auth');
					navigate('/');
				}
				return response;
			});
	}

	return { sendRequest };
};

export default CommonAPIService;
